if (!customElements.get('wishlist-counter')) {
  class WishlistCounter extends HTMLSpanElement {
    constructor() {
      super();

      this.registerEvents = this.registerEvents.bind(this);
      this.updateCount = this.updateCount.bind(this);

      this.registerEvents();

      if (!window.wishlist.customer) {
        const STORAGE_KEY = 'wishlist_items_handles';
        const storageValue = localStorage.getItem(STORAGE_KEY);

        let count = 0;
        if (storageValue) {
          count = JSON.parse(storageValue).length;
        }

        this.updateCount(count);
      }
    }

    registerEvents() {
      document.addEventListener('wishlist:updated', (event) => {
        this.updateCount(event.detail.count);
      });
    }

    /**
     * @param count {number}
     */
    updateCount(count) {
      this.textContent = count.toString();
      this.classList.toggle('hidden', count === 0);
    }
  }

  customElements.define('wishlist-counter', WishlistCounter, {
    extends: 'span',
  });
}
